import BaseNode from './BaseNode';
import RuleIcon from '@mui/icons-material/Rule';
import { colors } from '../../styles';

const ConditionalNode = ({ data }: { data: { label: string } }) => (
  <BaseNode label={data.label} typeLabel="Condição" accent={colors.primary.blue} icon={<RuleIcon />} />
);

export default ConditionalNode;
